// Tabs нет в новом ките, когда-нибудь компонент на замену
import { ITabProps } from '@cian/ui-kit/prev';

export class TabItemModel implements ITabProps {
  public readonly value: string;
  public readonly title: string;
  public readonly disabled: boolean;

  public constructor(value: string, title: string, disabled?: boolean) {
    this.value = value;
    this.title = title;
    this.disabled = !!disabled;
  }
}
